var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attr = ref.attr;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"to":_vm.newPageRoute,"target":"_blank","icon":"","small":""},on:{"click":function($event){$event.stopPropagation();}}},'v-btn',attr,false),on),[_c('v-icon',{attrs:{"color":"orange","dense":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }